<script>
import Quill from 'quill';
import QuillEditor from '../QuillEditor';

export default {
  name: 'nx-html-editor',
  extends: QuillEditor,
  props: {
    type: {
      type: String,
      default: 'basic',
    },
    editorName: {
      type: String,
      default: 'nx-html-editor',
    },
  },
  methods: {
    getContent() {
      let html = this.$refs.editor.children[0].innerHTML;
      if (html.trim() === '<p><br></p>') {
        html = '';
      }

      return html;
    },
    setContent(value) {
      if (!this.quill) return;
      if (!value) return;
      this.quill.clipboard.dangerouslyPasteHTML(value, Quill.sources.SILENT);
      this.quill.history.clear();
      this.$emit('length', this.textLength);
    },
  },
};
</script>
